/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){ .task-invoice-dialog{width:100%}}@media screen and (min-width:600px){ .task-invoice-dialog{width:400px}} .task-invoice-dialog .mat-dialog-container{padding:0} .task-invoice-dialog .mat-dialog-container .mat-toolbar{flex:1 0 auto;min-height:initial} .task-invoice-dialog .dialog-content-wrapper{max-height:85vh;display:flex;flex-direction:column} .task-invoice-dialog .general-info-step{padding:40px}"];
export { styles as styles };
